export const truncNumber = (n: number) =>
  n < 0 ? Math.ceil(n) : Math.floor(n);

/*
Based on sources (but with support of uneven timezones):
https://stackoverflow.com/questions/31096130/how-to-json-stringify-a-javascript-date-and-preserve-timezone/31104671
*/
const formatDateWithTimezone = (date: Date) => {
  const offsetInHours = -truncNumber(date.getTimezoneOffset() / 60);
  const offsetRemainderInMinutes = -(date.getTimezoneOffset() % 60);
  const sign = offsetInHours >= 0 ? '+' : '-';
  const hLeadingZero = Math.abs(offsetInHours) < 10 ? '0' : '';
  const mLeadingZero = Math.abs(offsetRemainderInMinutes) < 10 ? '0' : '';

  const correctedDate = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds(),
    date.getMilliseconds()
  );

  correctedDate.setHours(date.getHours() + offsetInHours);
  correctedDate.setMinutes(date.getMinutes() + offsetRemainderInMinutes);

  const iso = correctedDate.toISOString().replace('Z', '');

  return (
    `${iso}${sign}${hLeadingZero}${Math.abs(offsetInHours)}:${mLeadingZero}${Math.abs(offsetRemainderInMinutes)}`
  );
};

export default formatDateWithTimezone;
